import React, { useEffect, useRef, useState } from "react";
import { ElfsightWidget } from "react-elfsight-widget";
import { fetchWidgetStatus } from "../Transformations/NewsList";
import FLoader from "../Transformations/FLoader";

const LinkedInWidget = () => {
	const containerRef = useRef(null);
	const [activeWidget, setActiveWidget] = useState(null);

	useEffect(() => {
		// Fetch widget status and determine active widget
		const fetchStatus = async () => {
			try {
				const data = await fetchWidgetStatus();
				const [firstActiveWidget] = Object.entries(data)
					.filter(([_, { status }]) => status)
					.map(([key]) => key);
				// console.log("data", data);
				// console.log("firstActiveWidget", firstActiveWidget);
				setActiveWidget(firstActiveWidget || null);
			} catch (error) {
				console.error("Error fetching widget status:", error);
			}
		};

		fetchStatus();
	}, []);

	useEffect(() => {
		if (!activeWidget) return;

		// Function to handle mutations and check for target div
		const observeTargetDiv = () => {
			const observer = new MutationObserver((mutationsList) => {
				for (const mutation of mutationsList) {
					if (mutation.type === "childList") {
						const targetDiv = document.getElementById(
							`eapps-linkedin-feed-${activeWidget}`
						);
						if (targetDiv) {
							// Hide "Free LinkedIn Feed widget" link
							const elfsightLink = Array.from(
								document.querySelectorAll("a")
							).find((a) => a.innerText === "Free LinkedIn Feed widget");
							if (elfsightLink) {
								elfsightLink.style.display = "none";
							}
							observer.disconnect();
							break;
						}
					}
				}
			});

			// Start observing the container for changes
			if (containerRef.current) {
				observer.observe(containerRef.current, {
					childList: true,
					subtree: true,
				});
			}

			// Clean up observer on component unmount
			return () => observer.disconnect();
		};

		const disconnectObserver = observeTargetDiv();

		// Clean up observer when activeWidget changes or component unmounts
		return disconnectObserver;
	}, [activeWidget]);

	return (
		<>
			{" "}
			{activeWidget ? (
				<div className="main-fields blogs-section">
					<div className="field-hd">
						<h2>LinkedIn</h2>
					</div>
					<div className="linkedin-section py-1" ref={containerRef}>
						{activeWidget ? (
							<ElfsightWidget widgetId={activeWidget} lazy modern />
						) : (
							<FLoader />
						)}
					</div>
				</div>
			) : (
				""
			)}
		</>
	);
};

export default LinkedInWidget;
